import { getCategories } from '~/grid/utils/categoryNav';
import { getCategoryNavContainer } from '~/shared/utils/getCategoryNavContainer';
import { useRegion } from '~/techstyle-shared/react-intl';
import { useNav } from '~/techstyle-shared/react-navigation';

export function useActiveCategoryAndBreadcrumbs() {
  const region = useRegion();

  let categoryPath;
  let categoryNavContainer;

  if (process.browser) {
    categoryPath = new URL(window.location);
    categoryNavContainer = getCategoryNavContainer(
      region,
      categoryPath.pathname
    );
  }
  const categoryNavData = useNav(categoryNavContainer);

  if (categoryNavData?.data?.navItems?.length) {
    return getCategories({
      navItems: categoryNavData.data.navItems,
      asPath: categoryPath.pathname,
    });
  }

  return {};
}
